import React, { useEffect, useMemo } from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';
import LocalStorageService from '../../../services/localStorageService';

const FormItem = Form.Item;
const Option = Select.Option;

const defaultRules = [
  {
    required: true,
    message: '老师不能为空',
  },
];

const TeacherFormItem = (props) => {
  const { form, fetchTeacherList, teacherList, itemStyle } = props;
  const isTeacher = LocalStorageService.getCurrentRole() === 2;
  const currentTeacherId = LocalStorageService.getCurrentUserId();
  const layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  const rules = props.rules ? props.rules : defaultRules;
  const label = props.label ? props.label : '老师';
  const name = props.name ? props.name : 'teacher';
  const activeTeacherList = useMemo(() => {
    const activeList = teacherList.filter((item) => item.isActive !== false);
    if (!isTeacher || !currentTeacherId) {
      return activeList;
    }
    return activeList.filter((item) => item._id === currentTeacherId);
  }, [currentTeacherId, isTeacher, teacherList]);

  useEffect(() => {
    if (isTeacher && fetchTeacherList && activeTeacherList.length === 0) {
      fetchTeacherList();
    }
    if (isTeacher && activeTeacherList.length === 1) {
      form.setFieldsValue({ [name]: activeTeacherList[0]._id });
    }
  }, [activeTeacherList, fetchTeacherList, form, isTeacher, name]);

  return (
    <FormItem label={label} {...layouts} name={name} rules={rules} form={form}>
      <Select
        mode='single'
        showSearch
        optionFilterProp='children'
        filterOption={(input, option) =>
          String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onFocus={fetchTeacherList}
        style={itemStyle}
        placeholder='老师选择'
        allowClear={!isTeacher}
        onSelect={(v) => {
          form.setFieldsValue({ [name]: v });
        }}
      >
        {activeTeacherList.map((item) => {
          return (
            <Option value={item._id} key={item._id}>
              {item.cnname}
            </Option>
          );
        })}
      </Select>
    </FormItem>
  );
};

export default TeacherFormItem;
